<template>
  <a-modal
    title="浮动价"
    :width="1280"
    :visible="visible"
    @ok="() => { $emit('ok', { point_price_list: this.pointPriceList, point_pricing_info: this.pointPriceInfo}) }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-row :gutter="[16,16]" v-if="pointPriceInfo !== undefined && pointPriceInfo.price_type !== undefined && pointPriceInfo.price_type !== null">
        <a-col :span="24" v-if="pointPriceInfo">
          <a-divider orientation="left">浮动价基础数据</a-divider>
        </a-col>
        <a-col :span="8" v-if="pointPriceInfo.price_type.premium_discount">
          升贴水：<span class="important-content">{{ pointPriceInfo.price_type.premium_discount + '' }} {{ dictionaries.currency[pointPriceInfo.price_type.pricing_currency] }}</span>
        </a-col>
        <a-col :span="8" v-if="pointPriceInfo.price_type.price_fixing_fee">
          点价费：<span class="important-content">{{ pointPriceInfo.price_type.price_fixing_fee }} {{ dictionaries.currency[pointPriceInfo.price_type.pricing_currency] }}</span>
        </a-col>
        <a-col :span="8">
          转月费：<span class="important-content">{{ pointPriceInfo.price_type.monthly_transfer_fee }} {{ dictionaries.currency[pointPriceInfo.price_type.pricing_currency] }}</span>
        </a-col>
        <a-col :span="8">
          定价源：<span class="important-content">{{ pointPriceInfo.price_type.pricing_source }}</span>
        </a-col>
        <a-col :span="8">
          收款币种：<span class="important-content">{{ dictionaries.currency[pointPriceInfo.price_type.receive_pricing_currency] }}</span>
        </a-col>
        <a-col :span="8">
          汇率类型：<span class="important-content">{{ dictionaries.exchange_rate[pointPriceInfo.price_type.exchange_rate_type] }}</span>
        </a-col>
        <a-col :span="8">
          临时单价：<span class="important-content">{{ pointPriceInfo.price_type.unit_price }}</span>
        </a-col>
        <a-col :span="8">
          临时单价是否含税：<span class="important-content">{{ pointPriceInfo.price_type.is_tax_unit_price ? '是' : '否' }}</span>
        </a-col>
        <a-col :span="8">
          临时汇率：<span class="important-content">{{ pointPriceInfo.price_type.temp_exchange_rate }}</span>
        </a-col>
        <a-col :span="8">
          数量：<span class="important-content">{{ pointPriceInfo.price_type.pricing_count }}</span>
        </a-col>
        <a-col :span="8">
          合同金额：<span class="important-content">{{ pointPriceInfo.price_type.contract_amount }}</span>
        </a-col>
        <a-col :span="8">
          合同金额是否含税：<span class="important-content">{{ pointPriceInfo.price_type.is_tax_contract_amount ? '是' : '否' }}</span>
        </a-col>
        <a-col :span="24">
          <a-divider orientation="left">合约</a-divider>
        </a-col>
        <a-col :span="24">
          <div v-for="(futures_contract, index) in pointPriceInfo.price_type.futures_contract_list" :key="index">
            <a-row :gutter="[16,16]">
              <a-col :span="7">
                <span>{{ futuresContractPreTitle(index) }}</span>期货合约：<span class="important-content">{{ futures_contract.futures_contract.substring(0, 7) }}</span>
              </a-col>
              <a-col :span="7">
                <span>{{ futuresContractPreTitle(index) }}</span>锁价期限：<span class="important-content">{{ futures_contract.lock_up_date }}</span>
              </a-col>
              <a-col :span="10">
                <span>{{ futuresContractPreTitle(index) }}</span>默认计价期：<span class="important-content">{{ futures_contract.pricing_period_start_date }}~{{ futures_contract.pricing_period_end_date }}</span>
              </a-col>
            </a-row>
          </div>
        </a-col>
        <a-col :span="24">
          <a-divider orientation="left">明细</a-divider>
        </a-col>
        <a-col :span="2" style="text-align: center" v-if="false">
          <a-button @click="tasCreate">TAS</a-button>
        </a-col>
        <a-col :span="2" style="text-align: center">
          <a-button @click="triggerCreate">Trigger</a-button>
        </a-col>
        <a-col :span="2" style="text-align: center">
          <a-button @click="naturalPricingCreate">自然计价</a-button>
        </a-col>
        <a-col :span="24">
          <a-table
            style="width: 100%"
            v-if="pointPriceList.length > 0 "
            :data-source="pointPriceList"
            :columns="pointPriceColumns"
            :pagination="false">
            <span slot="serial" slot-scope="text, record, index">
              {{ index + 1 }}
            </span>
            <template slot="nature_lock_date" slot-scope="text">
              <span style="display: block" v-if="!text.includes(',')">
                {{ text }}
              </span>
              <span v-else >
                <span style="display: block" v-for="(item, index) in text.split(',')" :key="index">
                  {{ item }}
                </span>
              </span>
            </template>
            <template
              v-for="col in ['lock_price']"
              :slot="col"
              slot-scope="text, record"
            >
              <div :key="col">
                <a-input-number
                  v-if="record.editable"
                  style="margin: -5px 0"
                  :value="text"
                  :precision="4"
                  @change="e => handleChange(e, record.key, col)"
                />
                <template v-else>
                  {{ text }}
                </template>
              </div>
            </template>
            <template slot="action" slot-scope="text, record">
              <a v-if="record.lock_price_type === 3" @click="showLockPriceDetail(record)">明细</a>
              <a-divider v-if="record.lock_price_type === 3" type="vertical" />
              <a-popconfirm
                :title="deleteTitle(record)"
                @confirm="() => onDeleteItem(record)"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
              <a-divider v-if="record.lock_price_type === 3 && !record.editable" type="vertical" />
              <a v-if="record.lock_price_type === 3 && !record.editable" @click="editLockPrice(record.key)">编辑</a>
              <span v-if="record.editable">
                <a-divider type="vertical" />
                <a @click="() => saveLockPrice(record.key)">保存</a>
                <a-divider type="vertical" />
                <a-popconfirm title="确定取消吗?" @confirm="() => cancelLockPrice(record.key)">
                  <a>取消</a>
                </a-popconfirm>
              </span>
            </template>
          </a-table>
        </a-col>
      </a-row>
      <component
        :ref="currentComponent"
        @cancel="handleAddCancel"
        @ok="handleOk"
        :record="mdl"
        :is="currentComponent"
        :visible="createContractVisible"
        v-if="createContractVisible"
        :loading="confirmLoading"
        :model="mdl" />
      <a-modal
        title="明细"
        v-if="lockPriceDetailVisible"
        :visible="lockPriceDetailVisible"
        :footer="null"
        @cancel="lockPriceDetailVisible=false"
      >
        <div v-for="(item, index) in pointPriceDetailList" :key="index">
          <a-row :gutter="[16,16]">
            <a-col :span="12">
              计价日期：{{ item.lock_price_date }}
            </a-col>
            <a-col :span="12">
              计价价格：{{ item.lock_price }}
            </a-col>
          </a-row>
        </div>
      </a-modal>
    </a-spin>
  </a-modal>
</template>

<script>
import { Dictionaries } from '@/common/AllConstant'
import {
  sell_contract_list,
  sell_contract_valence_vertex_price_delete,
  sell_contract_valence_vertex_price_list
} from '@/api/trade_sell_contract'
import PointPriceApplyCreateForm from './PointPriceApplyCreateForm'
import PointPriceApplyNaturePriceCreateForm from './PointPriceApplyNaturePriceCreateForm'
import debounce from 'lodash/debounce'
import { project_list } from '@/api/trade_project'

export default {
  name: 'PointPriceApply',
  components: {
    PointPriceApplyCreateForm,
    PointPriceApplyNaturePriceCreateForm
  },
  props: {
    contract: {
      type: Object,
      default: () => {
        return null
      }
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    this.projectSearch = debounce(this.handleProjectSearch, 800)
    return {
      form: this.$form.createForm(this),
      dictionaries: Dictionaries,
      pointPriceInfo: undefined,
      currentComponent: '',
      createType: 0,
      mdl: {},
      loading: false,
      projectFetching: false,
      sellContractFetching: false,
      projectList: [],
      selectedProjectId: undefined,
      selectedProject: undefined,
      sellContractList: [],
      isServerData: false,
      lockPriceDetailVisible: false,
      createContractVisible: false,
      confirmLoading: false,
      pointPriceDetailList: [],
      pointPriceList: [],
      cachePointPriceList: [],
      editingKey: '',
      pointPriceColumns: [
        {
          title: '序号',
          width: 80,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '锁价日期',
          dataIndex: 'lock_date',
          width: 180,
          align: 'center',
          scopedSlots: { customRender: 'nature_lock_date' }
        },
        {
          title: '操作',
          dataIndex: 'lock_price_type',
          width: 120,
          align: 'center',
          ellipsis: true,
          customRender: (text) => this.$Dictionaries.trade_point_price_lock_type[text] || ''
        },
        {
          title: '锁价数量',
          dataIndex: 'lock_count',
          width: 120,
          align: 'center',
          ellipsis: true
        },
        {
          title: '锁价价格',
          dataIndex: 'lock_price',
          width: 150,
          align: 'center',
          ellipsis: true,
          scopedSlots: { customRender: 'lock_price' }
        },
        {
          title: '是否转月',
          dataIndex: 'is_rollover',
          width: 100,
          align: 'center',
          ellipsis: true,
          customRender: (text) => text ? '是' : '否'
        },
        {
          title: '月差',
          dataIndex: 'monthly_spread',
          width: 150,
          align: 'center',
          ellipsis: true
        },
        {
          width: 180,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  computed: {
    paymentMethodTitle () {
      return (payment_method) => {
        return '' + (this.dictionaries.trade_pre_payment_method[payment_method] || '')
      }
    },
    futuresContractPreTitle () {
      return (index) => {
        if (index === 0) {
          return ''
        } else if (index === 1) {
          return '转月后'
        } else if (index === 2) {
          return '二次转月后'
        } else {
          return (index + 1) + '次转月后'
        }
      }
    },
    deleteTitle () {
      return (record) => {
        return record.id > 0 ? '删除后数据不会恢复，确定删除吗？' : '确定删除吗？'
      }
    }
  },
  mounted () {
    this.loadPointPrice()
  },
  methods: {
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    handleProjectSearch (value) {
      this.projectFetching = true
      project_list({ name: value }).then((res) => {
        const result = res.data.entries || []
        this.projectList = !value ? (result.length > 5 ? result.slice(0, 5) : result) : result
      }).finally(() => {
        this.projectFetching = false
      })
    },
    handleProjectChange (value) {
      console.log(value)
      if (value === undefined) {
        this.handleProjectSearch(value)
      } else {
        this.selectedProjectId = value
        this.selectedProject = this.projectList.filter(item => item.id === this.selectedProjectId)[0]
        this.sellContractList = []
        this.form.setFieldsValue({
          sell_contract_id: undefined
        })
        this.form.setFieldsValue({
          client_ids: undefined
        })
        this.handleSellContractSearch()
      }
    },
    handleSellContractChange (value) {
      if (value !== undefined) {
        this.contract = this.sellContractList.filter(item => item.id === value)[0]
        console.log('合同信息', this.contract)
        this.loadPointPrice()
      }
    },
    handleSellContractSearch () {
      if (this.selectedProjectId === undefined) {
        return
      }
      this.sellContractFetching = true
      sell_contract_list({ project_id: this.selectedProjectId, is_expired: false, page: 1, page_size: 999 }).then((res) => {
        const result = res.data.entries || []
        this.sellContractList = result
      }).finally(() => {
        this.sellContractFetching = false
      })
    },
    loadPointPrice () {
      this.loading = true
      sell_contract_list({ id: this.contract.id }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.pointPriceInfo = res.data.entries[0]
          this.loadPointPriceDetail()
        }
      }).finally(() => {
        this.loading = false
      })
    },
    loadPointPriceDetail () {
      if (this.pointPriceInfo === undefined || this.pointPriceInfo.price_type === undefined || this.pointPriceInfo.price_type === null) {
        return
      }
      sell_contract_valence_vertex_price_list({ point_pricing_id: this.pointPriceInfo.price_type.id }).then(res => {
        if (res.code === 1000 && res.data.entries !== undefined && res.data.entries.length > 0) {
          this.pointPriceList = res.data.entries
          if (this.pointPriceList) {
            this.pointPriceList = this.pointPriceList.map((item, index) => {
              if (item.lock_price_type === 3) {
                if (item.is_consecutive_dates) {
                  item['lock_date'] = item['lock_price_start_date'] + '~' + item['lock_price_end_date']
                } else {
                  if (item['nature_price_list'] !== undefined && item['nature_price_list'].length > 0) {
                    item['lock_date'] = item['nature_price_list'].map(item => item.lock_price_date).join(',')
                  }
                }
              } else {
                item['lock_date'] = item['lock_price_start_date']
              }
              item['key'] = Math.random() * 100000 + index
              item['editable'] = false
              return item
            })
            this.cachePointPriceList = [...this.pointPriceList]
            this.isServerData = true
          }
        }
      })
    },
    tasCreate () {
      this.createType = 1
      this.currentComponent = 'PointPriceApplyCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    triggerCreate () {
      this.createType = 2
      this.currentComponent = 'PointPriceApplyCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    naturalPricingCreate () {
      this.createType = 3
      this.currentComponent = 'PointPriceApplyNaturePriceCreateForm'
      this.mdl['type'] = this.createType
      this.createContractVisible = true
    },
    handleAddCancel () {
      this.createContractVisible = false
      this.createType = 0
      this.mdl = {}
    },
    onDeleteItem (record) {
      const key = record.key
      const dataSource = [...this.pointPriceList]
      if (record.id) {
        const deleteDataList = dataSource.filter(item => item.key === key)
        if (deleteDataList !== undefined && deleteDataList.length > 0) {
          const deleteData = deleteDataList[0]
          if (deleteData.id) {
            sell_contract_valence_vertex_price_delete(deleteData.id).then(res => {
              if (res.code === 1000) {
                this.pointPriceList = dataSource.filter(item => item.key !== key)
              }
            })
          } else {
            const dataSource = [...this.pointPriceList]
            this.pointPriceList = dataSource.filter(item => item.key !== key)
          }
        }
      } else {
        const dataSource = [...this.pointPriceList]
        this.pointPriceList = dataSource.filter(item => item.key !== key)
      }
    },
    editLockPrice (key) {
      const newData = [...this.pointPriceList]
      const target = newData.find(item => key === item.key)
      this.editingKey = key
      if (target) {
        target.editable = true
        this.pointPriceList = newData
      }
    },
    saveLockPrice (key) {
      const newData = [...this.pointPriceList]
      const newCachePointPriceList = [...this.cachePointPriceList]
      const target = newData.find(item => key === item.key)
      const targetCache = newCachePointPriceList.find(item => key === item.key)
      if (target && targetCache) {
        delete target.editable
        this.pointPriceList = newData
        Object.assign(targetCache, target)
        this.cachePointPriceList = newCachePointPriceList
      }
      this.editingKey = ''
    },
    cancelLockPrice (key) {
      const newData = [...this.pointPriceList]
      const target = newData.find(item => key === item.key)
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cachePointPriceList.find(item => key === item.key))
        delete target.editable
        this.pointPriceList = newData
      }
    },
    handleChange (value, key, column) {
      const newData = [...this.pointPriceList]
      const target = newData.find(item => key === item.key)
      if (target) {
        target[column] = value
        this.pointPriceList = newData
      }
    },
    showLockPriceDetail (record) {
      this.pointPriceDetailList = record.nature_price_list
      this.lockPriceDetailVisible = true
    },
    checkLockDate (values) {
      const futures_contract_lock_date_list = this.pointPriceInfo.price_type.futures_contract_list.map(item => item.lock_up_date)
      console.log('===', futures_contract_lock_date_list)
      const lock_date = new Date(values['lock_date'])
      for (const futuresContractLockDate of futures_contract_lock_date_list) {
        const contractDate = new Date(futuresContractLockDate)
        console.log(contractDate, lock_date, contractDate > lock_date)
        if (contractDate > lock_date) {
          return true
        }
      }
      return false
    },
    checkLockCount (values) {
      const lock_count = parseFloat(values['lock_count'])
      const locked_count = this.pointPriceList.reduce((total, item) => {
        const val = parseFloat(item['lock_count'])
        return total + (isNaN(val) ? 0 : val)
      }, 0)
      const contract_max_count = this.contract.count * (1 + parseFloat(this.contract.overloading_rate)) - locked_count
      if (lock_count > contract_max_count) {
        return false
      }
      return true
    },
    handleOk (data) {
      const form = this.$refs[this.currentComponent].form
      form.validateFields((errors, values) => {
        if (!errors) {
          if (this.currentComponent === 'PointPriceApplyCreateForm') {
            if (!this.checkLockDate(values)) {
              this.$message.warning('锁价日期不在合同约定的锁价日期范围')
              return
            }
            if (!this.checkLockCount(values)) {
              this.$message.warning('锁价数量超出合同约定的数量范围')
              return
            }
          }
          const date = new Date()
          const key = date.getHours() + '' + date.getMinutes() + '' + date.getSeconds()
          if (this.createType === 3) {
            this.pointPriceList.push({ ...values, ...data, lock_price_type: this.createType, key: key, editable: false })
          } else {
            this.pointPriceList.push({ ...values, lock_price_type: this.createType, key: key, editable: false })
          }
          this.cachePointPriceList = this.pointPriceList.map(item => ({ ...item }))
          this.createContractVisible = false
        } else {
          this.confirmLoading = false
        }
      })
    }
  }
}
</script>

<style scoped>
.desc {
  padding-right: 20px;
  height: 40px;
  line-height: 40px;
  display: inline-block;
}
.row_item {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 20px;
  background-color: #f7f7f7;
  margin-top: 5px;
  border-radius: 10px;
}
.ope>span:hover {
  color: #2a99ff;
  cursor: pointer;
}
.ope>span:first-child {
  padding-left: 0px;
  height: 40px;
  line-height: 40px;
}
.ope>span:not(:first-child) {
  padding-left: 20px;
  height: 40px;
  line-height: 40px;
}
.content {
  /*color: #00A0E9;*/
  /*font-weight: bolder*/
}
.none {
  color: #333333;
}
.waiting {
  color: yellowgreen;
}
.pass {
  color: green;
}
.un_pass {
  color: red;
}
.space {
  margin-top: 5px;
  overflow-x: auto;
}
.important-content {
  font-weight: bold;
}
</style>
